import React from "react";
import { __ } from "@wordpress/i18n";
import { WpmudevIcon } from "../../icons";

const HeroSection = () => {
  return (
    <div className="cross-sell-hero">
      <div className="cross-sell-wrapper cross-sell-hero__wrapper">
        <h2>
          {__(
            "Explore our powerful WordPress plugins.",
            "plugin-cross-sell-textdomain"
          )}
        </h2>
        <p>
          {__(
            "Smart, reliable, and completely free - what’s not to love?",
            "plugin-cross-sell-textdomain"
          )}
        </p>
      </div>
      <div className="cross-sell-hero__logo">
        <WpmudevIcon />
      </div>
    </div>
  );
};

export { HeroSection };
